import IconButton from '@mui/material/IconButton';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CardFiles from '../../../../../components/CockpitCards/CardFiles';


export default function R2(data) {


return (
<>
<CardFiles 

    headline = "R2 FASTA" 
    subtext = "Here you can download the R2 file in fasta format. This file contains all the unaligned reads from genome sequencing."

    content_1 = {<>                        
            Sample: <br />
            Date: <br />
            Sequencer: <br />
            File Size: <br />
            Description: 
                           
         </>} 

content_2 = {<>                

{data.data[0]} <br />
{data.data[1]} <br />
{data.data[2]} <br />
~ 25 GB <br />
Unaligned<br />Reverse Strand
</>} 

action = {
<IconButton href = {data.data[3]} sx={{ color: 'success.light' }} >
    <CloudDownloadIcon sx={{fontSize: '2.5rem',}} /> 
</IconButton> 
}

/>    
</>

)};
